import axios from 'axios';
import React, {useState, useEffect, useMemo, Fragment, useRef} from 'react';

import { FormControl, InputLabel, Input, FormHelperText, Alert } from '@mui/material';
import WebService from '@util/webService'
import {encodeParams, getAction, getCodeName, printVariable} from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux';
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
import TableSortLabel from '@mui/material/TableSortLabel';
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ControlPointOutlined from '@mui/icons-material/ControlPointOutlined';
import DoNotDisturbOnOutlined from '@mui/icons-material/DoNotDisturbOnOutlined';
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField,withStyles,InputBase } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton';
import useSnackbar from '@hooks/useSnackbar';
import MyTableHead from '@components/MyTableHead';
import useIndicator from '@hooks/useIndicator';
import Indicator from '@components/Indicator';
import MyDialog from '@components/MyDialog';
import useForm from '@hooks/useForm';
import Box from '@mui/material/Box';
import ConfirmDialog from "@components/ConfirmDialog";
// pagination
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useLocation } from 'react-router-dom';
import {
  Avatar,
  Grid,
  Container,
  Select,
  MenuItem,
  Divider,
} from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import moment from 'moment';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { searchSchool } from '@util/helper';

import RegisterCompanyPage from '@pages/register/register-company.page';
import ProfileCompanySchoolPart from './profile-company.school.part';
import {useParams} from "react-router-dom";
import useAlert from "@hooks/useAlert";
const Boxs = styled(Box)`
      padding-bottom: 40px !important;
    `;


const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;

const ProfileCompanyTeacherPartTime = ({dgRef, oldDemand, callback}) => {
  console.log('oldDemand school=>', oldDemand.school)
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const {alert, renderAlert} = useAlert()
  const [report, set_report] = useState({})
  const [demand, set_demand] = useState({...oldDemand})
  const g_week_code = "SB07"
  const codes = useSelector(state => state.codeReducer)
  const weekCodes = codes.filter(r => r.codeGroupId === g_week_code)
  const account = useSelector(state => state.accountReducer)
  const [sch, set_sch] = useState({key: Date.now()})
  const [schools, set_schools] = useState([])
  const [school, set_school] = useState(oldDemand.school?? {})
  const [smsts, set_smsts] = useState([])
  const [smst, set_smst] = useState(oldDemand.smst?? {})
	const schola = useSelector((state) => state.scholaReducer)
  const theme = useTheme()

  const addToList = () => {
    if(!school.id) {
      alert('학교를 선택해 주세요.')
      return
    }
    if(!smst.id) {
      alert('학기를 선택해 주세요.')
      return
    }
    if(!sch.weekCode) {
      alert('요일을 선택해 주세요.')
      return
    }

    if(!sch.startTime) {
      alert('시작시간을 입력해 주세요.')
      return
    }
    else {
      const valid = moment(sch.startTime, 'HH:mm', true).isValid()
      if(!valid) {
        alert('시작시간이 형식에 맞지 않습니다.')
        return
      }
    }

    if(!sch.endTime) {
      alert('종료시간을 입력해 주세요.')
      return
    }
    else {
      const valid = moment(sch.endTime, 'HH:mm', true).isValid()
      if(!valid) {
        alert('종료시간이 형식에 맞지 않습니다.')
        return
      }
    }

    const isBefore = moment(sch.startTime, 'HH:mm').isBefore(moment(sch.endTime, 'HH:mm'))
    if(!isBefore) {
      alert('시작시간은 종료시간 전이어야 합니다.')
      return
    }

    const idx = demand.schs.findIndex(item  => 
      item.weekCode=== sch.weekCode && item.startTime === sch.startTime && item.endTime === sch.endTime
    )
    if(idx != -1) {
      alert('동일한 요건이 목록에 있습니다.')
      return
    }
    
    demand.schs.push(sch) 
    const newDemand = {...demand}
    set_demand(newDemand)
    set_sch({key:Date.now()})
  }

  const removeFromList = (item) => {
    const newDemand = {...demand}
    const idx = newDemand.schs.findIndex(r => r === item)
    if(idx != -1) {
      newDemand.schs.splice(idx, 1)
      set_demand(newDemand)
    }
  }

  const fetchSmsts = async(schoolId) => {
    const url = `/smst/${schoolId}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()

    if(resp.repCode != 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    console.log('records=>', records)
    const smsts = records.filter((r => r.phase <= 1.4)).sort((a,b)  => b.id - a.id)
    set_smsts(smsts)
    if(smsts.length == 1) {
      set_smst(smsts[0])
    }
  }

  const fetchSchools = async() => {
    let url = `/rltn/company/school/user/${account.user.id}`
    // const params = {rltnCode:'S002', statCode:'S002', schoolId:schola.id, pageNum:pageInfo.pageNum, pageSize:pageInfo.pageSize, terms:JSON.stringify(newTerms)}
    const params = {rltnCode:'S002', statCode:'S002', schoolId:schola.id }
    openIndicator()
    let resp = await WebService.get(url, params )
    closeIndicator()

    if(resp.repCode != 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)

    const companyUserRelationList = JSON.parse(repMessage.companyUserRelationList)
    const records = []
    companyUserRelationList.forEach(r => {
      records.push(r.school)
    })
     
    const newSchools = records.sort((a, b) => a.name.localeCompare(b.name))
    set_schools(newSchools)
    if(newSchools.length == 1) {
      set_school(newSchools[0])
    }
  }

  const onLoad = async () => {
    fetchSchools()
  }

  useEffect(() => {
    onLoad()
  },[])

  useEffect(() => {
    if(school.id) {
      fetchSmsts(school.id) 
    }
  }, [school])

  return(
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} style={{marginTop:10}}>
          <Grid container spacing={2} key={sch.key}>
            <Grid item xs={12} style={{display:'flex', justifyContent:'center', flexDirection:'column'}}>
              <Typography style={{}} >
                - 해당 학교, 학기의 요일 및 시간대에 출강이 가능한 강사를 검색 요건에 추가합니다.
              </Typography>
              <Typography style={{}}>
                - 학교에 종강 전인 학기가 1개 이상 있어야 요건을 추가할 수 있습니다.
              </Typography>
              <Typography style={{marginBottom:30}}>
                - 리셋 버튼을 클릭하면 요건이 초기화 됩니다.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs>
                  {
                    school.id ? (
                      <Typography style={{fontWeight:'bold'}}>{school.name}</Typography>
                    ) : (
                      <FormControl fullWidth>
                        <InputLabel id='school' size='small' >
                          학교 선택
                        </InputLabel>
                        <Select
                          labelId='school'
                          required
                          label='school'
                          size='small'
                          defaultValue= {demand.school}
                          value = {school}
                          onChange={async (e) => {
                            set_school(e.target.value)
                          }}>
                          {schools.map((row, index) => {
                            return (
                              <MenuItem key={index} value={row}>
                                {row.name}
                              </MenuItem>
                            )
                          })}

                        </Select>
                      </FormControl>

                    )
                  }

                </Grid>
                <Grid item xs>
                  {
                    smst.id? (
                      <Typography style={{fontWeight:'bold'}}>{smst.year}/{smst.gisu}</Typography>
                    ) : (
                      <FormControl fullWidth>
                        <InputLabel id='smst' size='small' >
                          학기 선택
                        </InputLabel>
                        <Select
                          labelId='smst'
                          required
                          label='smst'
                          size='small'
                          value = {smst}
                          onChange={async (e) => {
                            set_smst(e.target.value)
                          }}>
                          {smsts.map((row, index) => {
                            return (
                              <MenuItem key={index} value={row}>
                                {row.year}/{row.gisu}
                              </MenuItem>
                            )
                          })}

                        </Select>
                      </FormControl>

                    )
                  }

                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={3}>
              <FormControl fullWidth>
                <InputLabel id='weekCode' size='small' >
                  요일 선택
                </InputLabel>
                <Select
                  labelId='weekCode'
                  required
                  label='weekCode'
                  size='small'
                  value = {sch.weekCode}
                  onChange={async (e) => {
                    console.log('e=>', e.target.value)
                    const newSch= {...sch, weekCode:e.target.value}
                    set_sch(newSch)
                  }}>
                  {weekCodes.map((row, index) => {
                    return (
                      <MenuItem key={index} value={row.code}>
                        {row.name}
                      </MenuItem>
                    )
                  })}

                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <TextField fullWidth label='강좌 시작시간 예) 15:00'
                value = {sch.startTime}
                inputProps={{ maxLength: 5 }}
                onChange = {e => {
                  const newSch = {...sch, startTime :e.target.value}
                  set_sch(newSch)
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField fullWidth label='강좌 종료시간 예) 15:50'
                value = {sch.endTime}
                inputProps={{ maxLength: 5 }}
                onChange = {e => {
                  const newSch = {...sch, endTime:e.target.value}
                  set_sch(newSch)
                }}
              />
            </Grid>
            <Grid item xs={3} >
              <Button fullWidth size='medium' startIcon={<ControlPointOutlined/>} onClick={addToList}>추가</Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12} style={{minHeight:200}}>
          {
            demand.schs.length > 0 ? (
              demand.schs.map((item, index) => (
                <Grid key={index} container spaicing={2} style={{alignItems:'center'}}>
                  <Grid item xs={3}>
                    <Typography>{weekCodes.find(r => r.code === item.weekCode)?.name}</Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography>시작시간 {item.startTime}</Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography>종료시간 {item.endTime}</Typography>
                  </Grid>
                  <Grid item xs={3}>
                    {/* <Button fullWidth size='medium' startIcon={<DoNotDisturbOnOutlined/>} onClick={() => removeFromList(item)}>제거</Button> */}
                    <IconButton 
                      color='error'
                      onClick={() => {
                        removeFromList(item)
                      }}
                    >
                      <DoNotDisturbOnOutlined />
                    </IconButton>
                  </Grid>
                </Grid> 
              ))
            ) : (
              <Typography color={theme.palette.primary.main} style={{textAlign:'center'}}>요건이 추가되지 않았습니다.</Typography>
            )
          }
        </Grid>
        <Grid item xs={12} style={{display:'flex', justifyContent:'center'}}>
          <Button onClick={() => dgRef.current.close()} style={{marginRight:10}}>닫기</Button>
          <Button variant='contained'  style={{marginRight:10}}
            onClick={() => {
              set_school({})
              set_smst({})
              set_demand({schs:[]})
            }}
          >
            리셋
          </Button>
          <Button variant='contained' 
            onClick={() => {
              dgRef.current.close()
              if(callback) {
                const newDemand = {...demand, school: school, smst: smst}
                callback(newDemand)
              }
            }}
          >
            확인
          </Button>
        </Grid> 
      </Grid>
      <div>
         {renderIndicator()}
         {renderAlert()}

      </div>
    </div>
  )
}

export default ProfileCompanyTeacherPartTime
